import React, { Suspense } from 'react'
import { OrbitControls } from "@react-three/drei"
import Placeholder from './Placeholder.jsx'
import DetailsItem from './DetailsItem.jsx'

export default function ReleaseDetailsScene({ currentAlbum, price}) {

    return (
        <>
            <directionalLight castShadow position={[0, 0, 1]}/>
            <ambientLight intensity={0.5} />
            <OrbitControls enableZoom={false} enablePan={false} enableRotate={false}/>
            <Suspense fallback={<Placeholder position-y={1} scale={[20, 20, 20]} />}>
                <group>
                    <DetailsItem currentAlbum={currentAlbum} price={price}/>
                </group>
            </Suspense>
        </>
    )
}